import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "helpers/url_helper";
import { post } from "helpers/api_helper";

export const sendBroadcastMessage = createAsyncThunk(
    "sendBroadcastMessage",
    async ({ data, callback }, Thunk) => {
      try {
        let response = await post(URL.BROADCAST_MESSAGE, data);
        callback && callback(null,response);
        return response;
      } catch (error) {
        callback && callback(error);
        return Thunk.rejectWithValue(error);
      }
    }
  );
  export const getBroadcastList = createAsyncThunk(
    "getBroadcastList",
    async ({ data, callback }, Thunk) => {
      console.log(data,"data======chemist payload")
      try {
        let response = await post(`${URL.GET_BROADCAST_MESSAGE}`, data);
        console.log("response callback==>",response)
        callback && callback(null,response);
        return response;
      } catch (error) {
        console.log(error,"error message ")
        callback && callback(error);
        return Thunk.rejectWithValue(error);
      }
    }
  );
  export const getBroadcastDetail = createAsyncThunk(
    "getBroadcastDetail",
    async ({ id, callback }, Thunk) => {
      try {
        let response = await post(`${URL.GET_BROADCAST_MESSAGE_DETAIL}${id}`,{});
        console.log("response callback==>",response)
        callback && callback(null,response);
        return response;
      } catch (error) {
        console.log(error,"error message ")
        callback && callback(error);
        return Thunk.rejectWithValue(error);
      }
    }
  );